import { render, staticRenderFns } from "./SmallPurchase.vue?vue&type=template&id=68cb222a&scoped=true&"
import script from "./SmallPurchase.vue?vue&type=script&lang=js&"
export * from "./SmallPurchase.vue?vue&type=script&lang=js&"
import style0 from "./SmallPurchase.vue?vue&type=style&index=0&id=68cb222a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb222a",
  null
  
)

export default component.exports